import React, { useState, useEffect } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { NavLink } from "react-router-dom";
import Config from "../../config/config";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';
import HttpLinkServices from "../../services/HttpLinkServices";
import LmsService from "../../services/LmsService";
import thumb_certificate from "../../assets/img/certificate-400x225.jpg";
import thumb_opinion from "../../assets/img/sua-opiniao.png";
import thumb_proof from "../../assets/img/avaliacao-aprendizagem-400x225.jpg";
import {FaLock, FaCloudDownloadAlt, FaDownload, FaEye, FaUnlock, FaPlayCircle, FaTimesCircle, FaCheck} from "react-icons/fa";
import Axios from "axios";
import getCookie from "../Cookie/Cookie";
import AccountService from "../../services/AccountService";
import { useCompletedItemsOnTheTrail } from '../../hooks/CompletedItemsOnTheTrail';
import ErrorModal from "../Modal/ErrorModal";
import "./styles.css";
import thumb_asset from "../../assets/img/thumb-assets.png";


const accountService = new AccountService();

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const dam_client = new ApolloClient({
  link: HttpLinkServices.dam,
  cache: new InMemoryCache(),
});

const GET_TRAIL = gql`
  query getTrail($trail_id: Int!){
    trail(id:$trail_id){
      id, title, blockcontent, active
      ,proof{
        id, title
      }
    }
  }
`;

const GET_TRAILITEMS = gql`
  query getItens($trail_id: Int!){
    trailitems(trail_id:$trail_id) {
      trailitems{
        id, item_id, item_type
      }
    }
  }
`;

const GET_COURSE = gql`
  query getCourse($course_id: Int!){
    course(id:$course_id){
      id, title, thumbnail, video{
        id, thumbnail
      }
    }
  }
`;


const GET_ASSET = gql`
  query getAsset($dam_id: Int!){
    asset(id:$dam_id){
      id, title, thumbnail
    }
  }
`;

const GET_TRAIL_HAS_USER_ITEM = gql`
  query trail_has_user_item($trail_id: Int!){
    trail_has_user_item(trail_id:$trail_id) {
        id
      }
    }
`;

const GET_USER_HAS_VIDEO = gql`
         query user_has_video($course_id: Int!){
         user_has_video(course_id: $course_id) {
           id
      }
    }
`;

const ACCOUNT_FIELD_VALUE = {
  RAMO_DE_ATUACAO: {
    MEU_PORTO_SEGURO: 298188
  }
}


 function TrailCarousel(props) {

  const [inviteStatus, setInviteStatus ] = useState('');
  const [isMPS, setIsMPS ] = useState(false);


  //Array que irá guardar todos os itens que foram realmente completados/assistidos
  const [completedItems, setCompletedItems ] = useState([]);
  const [haveProof,setHaveProof] = useState(false);
  const { completedItemsOnTrail } = useCompletedItemsOnTheTrail();

  async function NPSSurveyAnswer() {
    const response = await Axios.get(`${Config.baseUrl}/api/v1/lms/resultado_pesquisa_nps`,{
      params:{
        item_id: props.trail_id,
        item_type: "trail",
        user_token: String(getCookie("token_user")),
      }
    });
    const inviteStatus = response.data ? response.data.SurveyInviteStatus : false;
    setInviteStatus(inviteStatus);
  }

  // Verifica se possui o ramo de atuação MPS(Meu Porto Seguro)
  async function checkIfItIsMPS(){
    const response = await accountService.getAuthenticatedUser();
    const { data } = await accountService.getUserMetas(response.data.get_authenticated_user.id);
    const userMetas = data.user.userMetas;

    const metasFiltered = userMetas.find((meta) =>
      meta.account_field_value.id === ACCOUNT_FIELD_VALUE.RAMO_DE_ATUACAO.MEU_PORTO_SEGURO
    );

    if (metasFiltered) {
      return setIsMPS(true);
    }

    setIsMPS(false);
    NPSSurveyAnswer();

  }

  useEffect(() => {

    checkIfItIsMPS();
  },[]);

  async function handleCheckURL(url, id) {
    const lmsService = new LmsService();
    const response = await lmsService.getTrail(id);

    // Google Tag Manager
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    const dataLayer = {
      event : 'solicitacao_servico',
      nome_servico : 'gerar_certificado:curso trail carousel',
      nome_curso :  response.data.trail.title || '',
      data_servico : formattedDate,
      produto : response.data.trail.title || '',
      brand : 'porto seguro',
      retorno : url ? 'sucesso' : 'erro',
      descricao : 'certificado gerado'
      }

      addToDataLayerGTM(dataLayer);
      window.customData.curso.indice = window.customData.curso.modulos;
      window.customData.curso.etapa = "emissao-de-certificado";

   }

  return (

    <Query
      fetchPolicy='no-cache'
      client={lms_client}
      variables={{ trail_id: props.trail_id }}
      query={GET_TRAIL}
    >
      {({ loading, error, data }) => {
        if (loading) return <div>Carregando...</div>;
        if (error){
          // Google Tag Manager
          addToDataLayerGTM({
            'event' : 'erro',
            'etapa' : 'erro ao buscar trilha'
          });
          return <ErrorModal />;
        };
        const trail = data.trail;
        setHaveProof(trail.proof)
        const is_answered = inviteStatus == 647390003 ? true : false;
        const npsReference = !is_answered ? "/trail/" + trail.id + "/reactionevaluation/" + props.trail_id : false;

        return (
          <Grid fluid>
            <Row>
              <Col md={12}>
                <h2 className="title">Módulos</h2>
                <div className="trail_bar vertical_carousel courseSideBar">
                  <Query
                    fetchPolicy='no-cache'
                    client={lms_client}
                    variables={{ trail_id: props.trail_id }}
                    query={GET_TRAILITEMS}
                  >
                    {({ loading, error, data }) => {
                      if (loading) return <div>Carregando...</div>;
                      if (error){
                        // Google Tag Manager
                        addToDataLayerGTM({
                          'event' : 'erro',
                          'etapa' : 'erro ao buscar lista de itens da trilha'
                        });
                        return <ErrorModal />;
                      };

                      var trailItems_data = data.trailitems.trailitems;
                      if(!isMPS && haveProof){
                        window.customData.curso.modulos = trailItems_data.length + 3;
                      } else if(!isMPS) {
                        window.customData.curso.modulos = trailItems_data.length + 1;
                      } else if (haveProof){
                        window.customData.curso.modulos = trailItems_data.length + 2;
                      }
                      if(props.item_type === "proof") {
                        window.customData.curso = {
                          ...window.customData.curso,
                          tipo: 'trilha',
                          brand: 'porto-seguro',
                          item: {
                            indice: trailItems_data.length + 1,
                            nome:'avaliacao-de-aprendizagem'
                          }
                        }
                      } else if(props.item_type === "reactionevaluation"){
                        window.customData.curso = {
                          ...window.customData.curso,
                          tipo: 'trilha',
                          brand: 'porto-seguro',
                          item: {
                            indice: haveProof ? trailItems_data.length + 2 : trailItems_data.length + 1,
                            nome:'queremos-sua-opiniao'
                          }
                        }
                      }
                      return (
                        <div className={"contentSideBar"}>
                          {data.trailitems.trailitems.map((item, key_item) => (
                            <div className="course-item-sider-bar">
                              {item.item_type == "course" ?

                                <Query
                                  fetchPolicy='no-cache'
                                  client={lms_client}
                                  variables={{ course_id: item.item_id }}
                                  query={GET_COURSE}
                                >
                                  {({ loading, error, data }) => {
                                    if (loading) return <div>Carregando...</div>;
                                    if (error){
                                      // Google Tag Manager
                                      addToDataLayerGTM({
                                        'event' : 'erro',
                                        'etapa' : 'erro ao buscar curso'
                                      });
                                      return <ErrorModal />;
                                    }

                                    if (!data.course) {
                                      return <span></span>
                                    }

                                    var course = data.course;

                                    if ((!course.video || !course.video.id) &&
                                        completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 &&
                                        completedItems.indexOf(item.item_type + "-" + item.item_id) === -1
                                    ) {
                                      const newItem = item.item_type + "-" + item.item_id;
                                      setCompletedItems([...completedItems, newItem ]);

                                    }

                                    return (
                                      <div key={course.id} className={"course-item-sider-bar " + (completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 ? "course-item-view" : "")}>
                                        { /*trail.blockcontent === 1 ||*/ completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 || (key_item > 0 && completedItemsOnTrail.indexOf(trailItems_data[key_item - 1].item_type + "-" + trailItems_data[key_item - 1].item_id) !== -1) ? // Se essa trilha tem trava e esse item já está liberado
                                          <NavLink
                                            data-gtm-type="click"
                                            data-gtm-clicktype="link"
                                            data-gtm-name={"modulo_" + course.title}
                                            activeClassName={"selected"}
                                            exact={true}
                                            to={"/trail/" + course.id + "/" + item.item_type + "/" + props.trail_id}>
                                            <div className="course-item-icon">
                                              {course.id == props.item_id && props.item_type == "course"
                                                  ? (
                                                      <FaEye color="#0046C0"/>
                                                  )
                                                  :
                                                  !course.video || !course.video.id ?
                                                  (
                                                      completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 ?
                                                          <FaCheck color="#07a803"/> : <FaUnlock color="#0046C0"/>
                                                  )
                                                  :
                                                  (
                                                      <Query
                                                          fetchPolicy='no-cache'
                                                          client={lms_client}
                                                          variables={{course_id: item.item_id}}
                                                          query={GET_USER_HAS_VIDEO}
                                                      >
                                                        {({loading, error, data}) => {
                                                          if (error) return <FaUnlock color="#0046C0"/>;
                                                          if (data.user_has_video) {
                                                            if (completedItems.indexOf(item.item_type + "-" + item.item_id) === -1) {

                                                              const newItem = item.item_type + "-" + item.item_id;

                                                              setCompletedItems([...completedItems, newItem]);
                                                            }
                                                            return <FaCheck color="#07a803"/>;
                                                          } else {
                                                            return <FaUnlock color="#0046C0"/>;
                                                          }
                                                        }}
                                                      </Query>
                                                  )
                                              }
                                            </div>

                                            <img src={(course.thumbnail ? Config.baseUrl + "/lms/assets/" + course.thumbnail : (course.video && course.video.thumbnail ? course.video.thumbnail : ""))} />
                                            <div className="title">
                                              {course.title}
                                            </div>
                                          </NavLink>
                                          :
                                          <a>
                                            <div className="course-item-icon">
                                              {course.id == props.item_id && props.item_type == "course"
                                                ? (
                                                  <FaEye color="#0046C0" />
                                                ) : (
                                                  <FaLock color="#ff5a40" />
                                                )}
                                            </div>

                                            <img src={(course.thumbnail ? Config.baseUrl + "/lms/assets/" + course.thumbnail : (course.video && course.video.thumbnail ? course.video.thumbnail : ""))} />
                                            <div className="title">
                                              {course.title}
                                            </div>

                                          </a>
                                        }

                                      </div>
                                    )
                                  }}
                                </Query>

                                :
                                <Query
                                  fetchPolicy='no-cache'
                                  client={dam_client}
                                  variables={{ dam_id: item.item_id }}
                                  query={GET_ASSET}
                                >
                                  {({ loading, error, data }) => {
                                    if (loading) return <div>Carregando...</div>;
                                    if (error){
                                      // Google Tag Manager
                                      addToDataLayerGTM({
                                        'event' : 'erro',
                                        'etapa' : 'erro ao buscar capa de cursos'
                                      });
                                      return <ErrorModal />;
                                    };

                                    var asset = data.asset;

                                    if (completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 &&
                                        completedItems.indexOf(item.item_type + "-" + item.item_id) === -1
                                    ) {
                                      const newItem = item.item_type + "-" + item.item_id;
                                      setCompletedItems([...completedItems, newItem]);
                                    }

                                    return (
                                      <div  key={asset.id} className={"course-item-sider-bar " + (completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 ? "course-item-view" : "")}>
                                        {/*trail.blockcontent === 1 || */ completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 || (key_item > 0 && completedItemsOnTrail.indexOf(trailItems_data[key_item - 1].item_type + "-" + trailItems_data[key_item - 1].item_id) !== -1) ? // Se essa trilha tem trava e esse item já está liberado
                                          <NavLink
                                            data-gtm-type="click"
                                            data-gtm-clicktype="link"
                                            data-gtm-name={asset.title}
                                            activeClassName={"selected"}
                                            exact={true}
                                            to={"/trail/" + asset.id + "/" + item.item_type + "/" + props.trail_id}>
                                            <div className="course-item-icon">
                                              {asset.id == props.item_id && props.item_type == "asset"
                                                  ? (
                                                      <FaEye color="#0046C0"/>
                                                  )
                                                  :
                                                  completedItemsOnTrail.indexOf(item.item_type + "-" + item.item_id) !== -1 ?
                                                      (
                                                          <FaCheck color="#07a803"/>
                                                      )
                                                      :
                                                      (
                                                          <FaUnlock color="#0046C0"/>
                                                      )
                                              }
                                            </div>

                                            <div class="course-item-download">
                                              <FaCloudDownloadAlt class={"icon-play"} size={36} color={"white"}/>
                                            </div>
                                            <img src={thumb_asset} />
                                            <div className="title">
                                              {asset.title}
                                            </div>

                                          </NavLink>
                                          :
                                          <a>
                                            <div className="course-item-icon">
                                              {asset.id == props.item_id && props.item_type == "asset"
                                                ? (
                                                  <FaEye color="#0046C0" />
                                                ) : (
                                                  <FaLock color="#ff5a40" />
                                                )}
                                            </div>

                                            <div class="course-item-download">
                                              <FaCloudDownloadAlt class={"icon-play"} size={36} color={"white"}/>
                                            </div>
                                            <img src={thumb_asset} />
                                            <div className="title">
                                              {asset.title}
                                            </div>
                                          </a>
                                        }
                                      </div>
                                    )
                                  }}
                                </Query>
                              }

                            </div>
                          ))}

                          {trail.proof &&
                            <div key={trail.proof.id}
                            className="course-item-sider-bar">
                              {(completedItemsOnTrail.length >= trailItems_data.length || props.item_type == "proof") ? // Desbloqueia a avaliação de desempenho se a trilha for aberta ou se o número de conteúdos concluídos for igual ao número de conteúdos
                                <NavLink
                                  data-gtm-type="click"
                                  data-gtm-clicktype="link"
                                  data-gtm-name={trail.proof.title}
                                  activeClassName={"selected"}
                                  exact={true}
                                  className="proof_slide"
                                  to={"/trail/" + trail.proof.id + "/proof/" + props.trail_id}>
                                  <div className="course-item-icon">
                                    {trail.proof.id == props.item_id && props.item_type == "proof"
                                      ? (
                                        <FaEye color="#0046C0" />
                                      ) : (
                                        <FaUnlock color="#0046C0" />
                                      )}
                                  </div>
                                  <img src={thumb_proof} />
                                </NavLink>
                                :
                                <a>
                                  <div className="course_btn_block"></div>
                                  <div className="course-item-icon">
                                    {trail.proof.id == props.item_id && props.item_type == "proof"
                                      ? (
                                        <FaEye color="#0046C0" />
                                      ) : (
                                        <FaLock color="#ff5a40" />
                                      )}
                                  </div>
                                  <img src={thumb_proof} />
                                </a>
                              }
                            </div>
                          }

                          {// NPS
                            !isMPS &&
                            <div key={trail.id} className="course-item-sider-bar">
                            {/*trail.blockcontent !== 1 || */(completedItemsOnTrail.length >= trailItems_data.length || props.item_type == "proof") ? // Desbloqueia a avaliação de desempenho se a trilha for aberta ou se o número de conteúdos concluídos for igual ao número de conteúdos
                              <NavLink
                                data-gtm-type="click"
                                data-gtm-clicktype="link"
                                data-gtm-name={trail.title}
                                activeClassName={"selected"}
                                exact={true}
                                className={`proof_slide ${is_answered && "disabled"}`}
                                to={ npsReference }>
                                <div className="course-item-icon">
                                  {!is_answered
                                    ? (
                                      <FaUnlock color="#0046C0" />
                                      ) :(
                                      <FaLock color="#ff5a40" />
                                    )}
                                </div>
                                <img src={thumb_opinion} />
                              </NavLink>
                              :
                              <a>
                                <div className="course_btn_block"></div>
                                <div className="course-item-icon">
                                  {trail.id == props.item_id && props.item_type == "proof"
                                    ? (
                                      <FaEye color="#0046C0" />
                                    ) : (
                                      <FaLock color="#ff5a40" />
                                    )}
                                </div>
                                <img src={thumb_opinion} />
                              </a>
                            }
                            </div>
                          // NPS END
                          }

                          {
                            trail.proof &&
                            <Query
                              client={lms_client}
                              fetchPolicy='no-cache'
                              variables={{ trail_id: props.trail_id }}
                              query={GET_TRAIL_HAS_USER_ITEM}
                            >
                              {({ loading, error, data }) => {
                                if (loading) return <div>Carregando...</div>;
                                if (error){
                                  // Google Tag Manager
                                  addToDataLayerGTM({
                                    'event' : 'erro',
                                    'etapa' : 'erro ao buscar itens da trilha do usuario'
                                  });
                                  return <ErrorModal />;
                                };

                                if (props.courseFinish) {
                                  var courseFinish = true;
                                  var urlDownloadCertificate = (Config.baseUrl + "/api/v1/lms/certified_trail_generat/?u="+ props.courseFinish);
                                }
                                else if (data.trail_has_user_item && data.trail_has_user_item.id) {
                                  var courseFinish = true;
                                  var urlDownloadCertificate = (Config.baseUrl + "/api/v1/lms/certified_trail_generat/?u="+ data.trail_has_user_item.id);
                                }
                                else {
                                  var courseFinish = false;
                                  var urlDownloadCertificate = false;
                                }

                                return (
                                  <div key={1} className="course-item-sider-bar">
                                    <a
                                      className={`proof_slide ${!courseFinish && "disabled"}`}
                                      data-gtm-type="click" data-gtm-clicktype="download"
                                      data-gtm-name="emissão de certificado"
                                      href={urlDownloadCertificate} target="_blank"
                                      onClick={() => handleCheckURL(urlDownloadCertificate, props.trail_id)}>

                                      <div className="course-item-icon">
                                        {courseFinish
                                          ? (
                                            <FaUnlock color="#0046C0" />
                                          ) : (
                                            <FaLock color="#ff5a40" />
                                          )}
                                      </div>

                                      <img src={thumb_certificate} />
                                    </a>
                                  </div>
                                );
                              }}
                            </Query>
                          }
                        </div>

                      )
                    }}
                  </Query>
                </div>
              </Col>
            </Row>
          </Grid>
        )
      }}
    </Query>
  )
}

export default TrailCarousel;



// WEBPACK FOOTER //
// ./src/components/CoursePage/TrailCarousel.jsx